import { IAppState } from '../../redux';

export function selectIsBetChanged(state: IAppState): boolean {
  return state.auction.isBetChanged;
}
